import * as uuid from 'uuid';

import { type AdvancedFilterCondition } from '../types';
import {
  type AdvancedFiltersConditionPrivateState,
  type AdvancedFiltersConditionRowState,
  type AdvancedFiltersPublicState,
} from '../types/state.types';

export const assignUuidToAdvancedFilterConditions = (
  conditions: AdvancedFiltersConditionRowState[],
): AdvancedFiltersConditionPrivateState => {
  const advancedFilterInternal: AdvancedFiltersConditionPrivateState = {};
  for (const condition of conditions) {
    const id = uuid.v4();
    advancedFilterInternal[id] = condition;
  }

  return advancedFilterInternal;
};

export const advancedFilterConditionIsComplete = (
  condition: AdvancedFiltersConditionRowState,
): condition is AdvancedFilterCondition => {
  const { field, operator, value } = condition;
  return (
    field !== undefined &&
    field !== '' &&
    operator !== undefined &&
    operator !== '' &&
    value !== undefined
  );
};

export const initialiseAdvancedFiltersReducer = (
  defaultAdvancedFilters: AdvancedFiltersPublicState | undefined,
) => {
  if (
    !defaultAdvancedFilters ||
    defaultAdvancedFilters.conditions.length === 0
  ) {
    // initialize with a single empty condition row
    return {
      conditionCombineMode: 'and' as const,
      conditions: assignUuidToAdvancedFilterConditions([{}]),
    };
  } else {
    // initialize with the provided defaults
    return {
      conditionCombineMode: defaultAdvancedFilters.conditionCombineMode,
      conditions: assignUuidToAdvancedFilterConditions(
        defaultAdvancedFilters.conditions,
      ),
    };
  }
};
